import { createContext, useContext, ReactNode } from 'react';
import type { TenantContext as TenantContextType, MDA } from '@/types';
import { useAuth } from './AuthContext';

interface TenantContextValue {
  tenant: TenantContextType | null;
  mda: MDA | null;
  isLoading: boolean;
}

const TenantContext = createContext<TenantContextValue | null>(null);

export function TenantProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated: _isAuthenticated, isPlatformAdmin: _isPlatformAdmin } = useAuth();

  // For now, tenant info comes from the auth token
  // In a full implementation, you might fetch additional MDA details
  const tenantValue: TenantContextValue = {
    tenant: null, // Will be populated from auth context
    mda: null,
    isLoading: false,
  };

  return (
    <TenantContext.Provider value={tenantValue}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}
